import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPaymentInformationDTO } from '../models/transaction.store.model';
import { TransactionStoreState } from '../states/transaction-store.state';

@Injectable({
  providedIn: 'root',
})
export class TransactionStoreAction {
  // CONSTRUCTOR
  constructor(
    private _transactionStoreState: TransactionStoreState
  ) {}

  // METHODS

  // METHODS CRUD
  public read(method: string) {
    return this._transactionStoreState[method]();
  }

  public update(method: string, newState: IPaymentInformationDTO | any) {
    this._transactionStoreState[method](newState);
  }

  public delete(method: string) {
    this._transactionStoreState[method](null);
  }

  signUp(observe: string): Observable<IPaymentInformationDTO | any> {
    return this._transactionStoreState[observe];
  }
}
